import { render, staticRenderFns } from "./CategoryIcons.vue?vue&type=template&id=4f686465&scoped=true&"
var script = {}
import style0 from "./CategoryIcons.vue?vue&type=style&index=0&id=4f686465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f686465",
  null
  
)

component.options.__file = "CategoryIcons.vue"
export default component.exports